import { alertReducer } from "@redux/reducers/alert";
import { allUsersReducer } from "@redux/reducers/allUsers";
import { loginReducer } from "@redux/reducers/login";
import matchesActivesReducer from "@redux/reducers/matches-actives";
import promoCodesReducer from "@redux/reducers/promo-codes";
import revenueCatLogsReducer from "@redux/reducers/revenue-cat-logs";
import { userSearchReducer } from "@redux/reducers/user-search";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    loginReducer,
    userSearchReducer,
    allUsersReducer, // Add the new reducer here
    alertReducer,
    promoCodesReducer,
    matchesActivesReducer,
    revenueCatLogsReducer,
});

export default rootReducer;
